import { ChevronDown, ChevronRight } from 'lucide-react';
import type { ReactNode } from 'react';

interface IndentedRowProps {
  level: number;
  expanded: boolean;
  onToggleExpand: () => void;
  hasChildren: boolean;
  children: ReactNode;
  className?: string;
}

export function IndentedRow({
  level,
  expanded,
  onToggleExpand,
  hasChildren,
  children,
  className = '',
}: IndentedRowProps) {
  const indent = level * 20; // 20px per level

  return (
    <div
      className={`flex items-center gap-1 py-0.5 ${className}`}
      style={{ paddingLeft: `${indent}px` }}
    >
      {/* Expand/Collapse Toggle */}
      {hasChildren ? (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onToggleExpand();
          }}
          className="flex h-5 w-5 items-center justify-center rounded hover:bg-interactive-hover"
          aria-label={expanded ? 'Collapse' : 'Expand'}
        >
          {expanded ? (
            <ChevronDown className="h-4 w-4 text-content-secondary" />
          ) : (
            <ChevronRight className="h-4 w-4 text-content-secondary" />
          )}
        </button>
      ) : (
        <div className="h-5 w-5" /> // Spacer for items without children
      )}

      {/* Content */}
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
}
